var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { BetBtn } from "../BetBtn";
var BetBtnMultiview = /** @class */ (function (_super) {
    __extends(BetBtnMultiview, _super);
    function BetBtnMultiview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetBtnMultiview.prototype.renderContent = function () {
        return (React.createElement("div", { className: "rj-ev-list__bet-btn__inner", "data-uat": "div-ev-list-bet-btn-inner" },
            this.renderPoints(),
            this.renderOdds()));
    };
    return BetBtnMultiview;
}(BetBtn));
export { BetBtnMultiview };
//# sourceMappingURL=BetBtnMultiview.js.map